import { useApartment } from './useApartment'

export function useProperty() {
  const apartment = useApartment()

  return apartment ? apartment.unit.unit_type.property : null
}
